<template>
  <div class="body">
    <Home-Header :navindex="0"></Home-Header>
    <Home-Swiper :slideindex="0"></Home-Swiper>
    <div class="content-wrapper">
      <!-- <Home-Activity ></Home-Activity> -->
      <Home-Lowprice :bg="bgf8f6f9"></Home-Lowprice>
      <Home-Technology ></Home-Technology>
      <Home-Flexiblecharge ></Home-Flexiblecharge>
      <Home-Businessphilosophy ></Home-Businessphilosophy>
      <Home-Teamfounders :bg="bgfff"></Home-Teamfounders>
      <Home-QA :bg="bgf8f6f9"></Home-QA>
    </div>
    <Home-Safe></Home-Safe>
    <Home-Floatbar></Home-Floatbar>
    <Home-Footer></Home-Footer>
    <Home-Footerfrom></Home-Footerfrom>
    <!-- <a id="newBridge-left"  href="http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn"  rel='nofollow' target="_blank" ></a> -->
  </div>
</template>

<script>
import HomeHeader from '../common/Header'
import HomeSwiper from '../common/Swiper'
// import HomeActivity from './components/Activity'
import HomeTechnology from './components/Technology'
import HomeLowprice from './components/Lowprice'
import HomeFlexiblecharge from './components/Flexiblecharge'
import HomeBusinessphilosophy from './components/Businessphilosophy'
import HomeTeamfounders from '../common/Teamfounders'
import HomeQA from '../common/QA'
import HomeSafe from '../common/Safe'
import HomeFloatbar from '../common/Floatbar'
import HomeFooter from '../common/Footer'
import HomeFooterfrom from '../common/Footerfrom'
export default {
  name: 'Home',
  metaInfo: {
    title: '企业代理记账-上海机巧科技有限公司',
    meta: [
      { name: 'keywords', content: '注册公司_上海注册公司_注册上海公司_财务代理_上海代理记账' },
      { name: 'description', content: '机巧科技专注为企业提供智能财务SaaS解决方案及商脉资源拓展对接服务。提供：会计代理记账,公司注册代办服务,为初创小微企业提供了便捷的拍照式记账报税新体验，为中小企业解决财务方面的难题和痛点,同时也降低用人成本.' }
    ]
  },
  components: {
    HomeHeader, HomeSwiper, HomeTechnology, HomeLowprice, HomeFlexiblecharge, HomeBusinessphilosophy, HomeTeamfounders, HomeQA, HomeSafe, HomeFloatbar, HomeFooter, HomeFooterfrom
  },
  data () {
    return {
      list1: [],
      list2: [],
      list3: [],
      bgf8f6f9: 'bgf8f6f9',
      bgfff: 'bgfff'

    }
  },
  mounted () {
  }
}
</script>

<style scoped>
.content-wrapper{
  margin-top: 72px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue